module.exports = __webpack_public_path__ + "img/changj.1515f9b3.png";